/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const CheckCircled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Check circled"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#0E0E0E"
        d="M20.333 12A8.333 8.333 0 1 0 12 20.333V22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10v-1.667A8.333 8.333 0 0 0 20.333 12"
      />
      <path
        fill="#0E0E0E"
        d="M11.142 14.259a.89.89 0 0 1 0 1.235.837.837 0 0 1-1.204 0l-2.689-2.758a.89.89 0 0 1 0-1.235.837.837 0 0 1 1.205 0z"
      />
      <path
        fill="#0E0E0E"
        d="M15.546 8.506a.836.836 0 0 1 1.204 0 .89.89 0 0 1 0 1.235l-5.608 5.753a.837.837 0 0 1-1.204 0 .89.89 0 0 1 0-1.235z"
      />
    </g>
  </svg>
);

export const CheckCircledIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'check-circled-icon'}
      icon={CheckCircled}
      {...props}
      size={size}
    />
  );
};
